import { useTranslation } from 'react-i18next';
import Reveal from '../../components/Reveal';
import { FEAT_KEYS, ICON_BG } from './constants';

export default function Features() {
  const { t } = useTranslation();

  return (
    <section id="features" className="py-20 px-6 max-w-6xl mx-auto">
      <Reveal>
        <h2 className="text-2xl sm:text-3xl font-bold text-center text-gray-900 mb-2">{t('landing.features.title')}</h2>
        <p className="text-center text-sm text-gray-400 mb-12 max-w-xl mx-auto">{t('landing.features.subtitle')}</p>
      </Reveal>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
        {FEAT_KEYS.map(({ key, icon: Icon, color }, i) => (
          <Reveal key={key} delay={i * 80}>
            <div className="h-full p-5 border border-gray-100 rounded-2xl hover:border-transparent hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
              <div className={`p-3 bg-gradient-to-br ${ICON_BG[color]} rounded-2xl w-fit mb-4 shadow-lg`}>
                <Icon size={18} className="text-white" />
              </div>
              <p className="text-sm font-semibold text-gray-800">{t(`landing.features.items.${key}.title`)}</p>
              <p className="text-xs text-gray-400 mt-1.5 leading-relaxed">{t(`landing.features.items.${key}.desc`)}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
